import { Shark, SmartModel } from "shark-mvc";

class ImageExifData extends SmartModel {
	FileName = "";
	FileDateTime = 0;
	FileSize = 0;
	// "FileType": 2,
	MimeType = "";
	SectionsFound = "";
	COMPUTED = {
	// 	"html": "width=\"7208\" height=\"4817\"",
		"Height": 0,
		"Width": 0,
	// 	"IsColor": 0,
	// 	"ByteOrderMotorola": 1,
	// 	"Copyright": "1999 Joe McNally",
	// 	"Thumbnail.FileType": 2,
	// 	"Thumbnail.MimeType": "image/jpeg"
	};
	ImageHeight = 0;
	ImageLength = 0;
	ImageWidth = 0;
	// "BitsPerSample": [
	// 	8,
	// 	8,
	// 	8
	// ],
	Compression = 0;
	// "PhotometricInterpretation": 2,
	ImageDescription = "";
	Orientation = 0;
	// "SamplesPerPixel": 3,
	// "XResolution": "1181102/10000",
	// "YResolution": "1181102/10000",
	// "PlanarConfiguration": 1,
	// "ResolutionUnit": 3,
	// "Software": "Adobe Photoshop CC 2014 (Macintosh)",
	DateTime = "";
	Artist = "";
	Copyright = "";
	// "Exif_IFD_Pointer": 668,
	// "THUMBNAIL": {
	// 	"Compression": 6,
	// 	"XResolution": "72/1",
	// 	"YResolution": "72/1",
	// 	"ResolutionUnit": 2,
	// 	"JPEGInterchangeFormat": 818,
	// 	"JPEGInterchangeFormatLength": 10647
	// },
	ExifVersion = "";
	// "ColorSpace": 65535,
	ExifImageWidth = 0;
	ExifImageLength = 0;

	rawData = null;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}
}

Shark.registerModel("ImageExifData", ImageExifData);

export default ImageExifData;